/* ── incident statuses – single source of truth for the UI ── */

// label = badge text, name = legend text, short = status button text in the modal
export const STATUS_META = {
  1: { label: 'PRIJATÉ',          name: 'Prijaté',          short: 'Prijaté',   color: '#5abbff', bg: '#0e2233', border: '#5abbff' },
  2: { label: 'V RIEŠENÍ',        name: 'V riešení',        short: 'V riešení', color: '#e88e39', bg: '#2d1f0d', border: '#e88e39' },
  3: { label: 'VYRIEŠENÉ',        name: 'Vyriešené',        short: 'Vyriešiť',  color: '#52c41a', bg: '#152615', border: '#52c41a' },
  4: { label: 'ZAMIETNUTÉ',       name: 'Zamietnuté',       short: 'Zamietnuť', color: '#ff4d4f', bg: '#2d1010', border: '#ff4d4f' },
  5: { label: 'BACKLOG',          name: 'Backlog',          short: 'Backlog',   color: '#a78bfa', bg: '#1c1730', border: '#a78bfa' },
  6: { label: 'DEPLOYED TO TEST', name: 'Deployed to TEST', short: 'TEST',      color: '#13c2c2', bg: '#0b2b2b', border: '#13c2c2' },
  7: { label: 'DEPLOYED TO PROD', name: 'Deployed to PROD', short: 'PROD',      color: '#36cfc9', bg: '#0d2a2a', border: '#36cfc9' },
};

// Workflow order for buttons, filters and legends
export const STATUS_ORDER = [5, 1, 2, 6, 7, 3, 4];
export const OPEN_STATUSES = [1, 2, 6];
export const RESOLVED_STATUSES = [3, 7];
export const CLOSED_STATUSES = [3, 4, 7];

// Incident list rows/legend mute the resolved status
export const LIST_STATUS_META = { ...STATUS_META, 3: { ...STATUS_META[3], color: '#798279' } };

export const STATUS_OPTIONS =STATUS_ORDER.map(code => ({ value: String(code), label: STATUS_META[code].label }));

export const isResolved = (code) => RESOLVED_STATUSES.includes(Number(code));
export const isOpen = (code) => OPEN_STATUSES.includes(Number(code));

export const getStatusMeta = (code) => STATUS_META[code] || {
  label: String(code), name: String(code), short: String(code), color: '#888', bg: '#222', border: '#888',
};
